type T = (text: string, elementId?: string) => void;

const f: T = (text, elementId = 'output') => {
    const element = document.getElementById(elementId);

    if (element) {
        element.innerText = text;
    }
};

export default f;
